import { SimpleGrid, Square, Text, Box, Center, Container } from '@chakra-ui/react';
import React from 'react';

const Inspiration = () => {
    return (
        <>

            <div style={{ backgroundImage: 'linear-gradient(to bottom, #0a3272, white)' }}>

                <Text
                    // fontWeight="bold"
                    textTransform="uppercase"
                    p={'4px'}
                    pb={'12px'}
                    // align={"right"}
                    fontSize={["30", "33"]}
                    letterSpacing="wide"
                    color="black"
                    pt={[2, 5, 10]}
                    px={[4, 10, 20]}
                    fontWeight='extrabold'
                >
                    बीमा सहायता

                </Text>

                <SimpleGrid columns={1} spacingX={8} mb={7} mt={5}>
                    <Center as={"text"} h='100px' textAlign={'left'} p='3%'
                        fontWeight="bold"
                        textTransform="uppercase"
                        fontSize={["8", "16"]}
                        letterSpacing="wide"
                        color="teal.800"
                    >
                        खिलाड़ीयों के सर्वांगीण विकास के लिए बेहतर प्रशिक्षण जरूरी है। इसके साथ ही खेल  के दौरान खिलाड़ियों को मैदान में  आने वाले चोटों के इलाज के लिए  बिहार सरकार 'प्रेरणा', 'सक्षम' और 'उड़ान' जैसे बीमा कवरेज पर विचार कर रही है।  इसके अलावा जो खिलाड़ी अंतर्राष्ट्रीय प्रशिक्षण और प्रतियोगिताओं के लिए यात्रा करते हैं, उन्हें बीमा कवरेज प्रदान की जाएगी
                        ।
                        </Center>
                </SimpleGrid>
            </div>


        </>
    )

}
export default Inspiration